export default {
    setUser           : (state, value) => (state.user = value),
    setUsers          : (state, users) => (state.users = users),
    setUserOneSignalID: (state, value) => {
        state.user.one_signal_id = state.user.one_signal_id || [];

        if (state.user.one_signal_id.indexOf(value) === -1) {
            state.user.one_signal_id.push(value);
        }
    }
};
